import React from 'react';
import { makeStyles } from '@material-ui/core';
import Sidenav from '../Sidenav';
import Faq from '../Faq';
import Navbar from '../Navbar';
import { useParams } from 'react-router-dom';


const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    background: '#fff',
    minHeight: '100vh'
  },
  content: {
    flexGrow: 1,
    padding: '75px 24px 24px 24px',
    width: 'calc(100% - 240px)'
  },
}));


const EntryContainer = ({ faqs }) => {
  const classes = useStyles();

  const [isDrawerOpen, setDrawerOpen] = React.useState(false);
  const [faq, setFaq] = React.useState({});
  const { parentslug, childslug } = useParams()

  React.useEffect(() => {
    if (faqs && faqs.length)
      setDefaultFaq();
  }, [faqs, parentslug, childslug])

  const setDefaultFaq = () => {
    let selectedFaq = {};
    let activeFaq = faqs.find(({ slug }) => slug === `/${parentslug}`);
    if (!activeFaq) selectedFaq = Object.assign({}, faqs[0]);
    else selectedFaq = Object.assign({}, activeFaq);
    setFaq(selectedFaq);
  }

  const toggleSideMenu = () => {
    setDrawerOpen(!isDrawerOpen);
    console.log('Toggle menu', isDrawerOpen);
  }

  const getMenuItems = (items = []) => {
    return items.map(e => {
      return { slug: e.slug, title: e.title }
    })
  }


  return (
    <React.Fragment>
      {faq &&
        <React.Fragment>
          <Navbar
            menuItems={getMenuItems(faq.subFaqs)}
            title={faq.title}
            toggleMenu={toggleSideMenu} />
          <Sidenav
            menuItems={getMenuItems(faq.subFaqs)}
            title={faq.title}
            isDrawerOpen={isDrawerOpen}
            toggleMenu={setDrawerOpen} />
          <main className={classes.content}>
            <Faq childFaqs={faq.subFaqs} />
          </main>
        </React.Fragment>
      }
    </React.Fragment>

  )
}

export default EntryContainer;



// WEBPACK FOOTER //
// ./src/Components/EntryContainer/index.js